import { render, staticRenderFns } from "./UserNewGroupModal.vue?vue&type=template&id=425d2e22&scoped=true&"
import script from "./UserNewGroupModal.vue?vue&type=script&lang=ts&"
export * from "./UserNewGroupModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserNewGroupModal.vue?vue&type=style&index=0&id=425d2e22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425d2e22",
  null
  
)

export default component.exports